import{m as o}from"./ninox-components-2ADN25D5.js";import{k as i}from"./ninox-components-R4FVH3NU.js";import{a as r}from"./ninox-components-I2GBTDK4.js";import e from"styled-components";var t=e.fieldset`
    display: flex;
    flex-flow: row nowrap;
    gap: ${o.tiny};
    padding: 0;
    margin: 0;
    border-width: 0;
`,p=e.input`
    appearance: none;
    background: none;
    border: none;
    inline-size: 100%;
    block-size: 100%;
    margin: 0;
    outline: none;
`,s=e.label`
    display: grid !important;

    & > * {
        grid-area: 1 / 1;
        pointer-events: none;
    }
`,d=e.legend`
    color: ${({theme:n})=>n.text.label};
    padding: 0;
    margin-inline-end: auto;
    margin-block-end: ${o.xxx_small};

    ${t}:active &,
    ${t}:focus-within & {
        color: ${({theme:n})=>n.text.primary};
    }

    ${t}:focus-within:hover & {
        color: ${({theme:n})=>n.text.secondary};
    }

    font-family: inherit;
    font-size: ${i.x_small};
    font-weight: ${r.medium};
    text-wrap: balance;

    transition-property: color;
    transition-timing-function: ease;
    transition-duration: 150ms;
`;export{t as a,p as b,s as c,d};
//# sourceMappingURL=ninox-components-7B2J5YY6.js.map